import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card card-empty" }
const _hoisted_2 = {
  key: 0,
  class: "details-content"
}
const _hoisted_3 = { class: "controls" }
const _hoisted_4 = { class: "details-header" }
const _hoisted_5 = {
  key: 0,
  class: "details-row details-row--adaptive"
}
const _hoisted_6 = { class: "details-value" }
const _hoisted_7 = {
  key: 1,
  class: "details-row details-row--adaptive"
}
const _hoisted_8 = { class: "details-value" }
const _hoisted_9 = {
  key: 2,
  class: "details-row details-row--adaptive"
}
const _hoisted_10 = { class: "details-value" }
const _hoisted_11 = {
  key: 3,
  class: "details-row details-row--adaptive"
}
const _hoisted_12 = { class: "details-value" }
const _hoisted_13 = {
  key: 4,
  class: "details-row details-row--adaptive"
}
const _hoisted_14 = { class: "details-value" }
const _hoisted_15 = {
  key: 0,
  class: "details-row details-row--adaptive"
}
const _hoisted_16 = { class: "details-value" }
const _hoisted_17 = {
  key: 1,
  class: "details-row details-row--adaptive"
}
const _hoisted_18 = { class: "details-value" }
const _hoisted_19 = { class: "details-block bordered" }
const _hoisted_20 = {
  key: 0,
  class: "details-row details-row--adaptive bordered details-row--buyer-type"
}
const _hoisted_21 = { class: "details-value" }
const _hoisted_22 = {
  key: 1,
  class: "details-row details-row--adaptive bordered"
}
const _hoisted_23 = { class: "details-value" }
const _hoisted_24 = {
  key: 0,
  class: "details-block bordered"
}
const _hoisted_25 = {
  key: 0,
  class: "details-row details-row--adaptive"
}
const _hoisted_26 = { class: "details-value" }
const _hoisted_27 = {
  key: 1,
  class: "details-row details-row--adaptive"
}
const _hoisted_28 = { class: "details-value" }
const _hoisted_29 = {
  key: 2,
  class: "details-row details-row--adaptive"
}
const _hoisted_30 = { class: "details-value" }
const _hoisted_31 = {
  key: 3,
  class: "details-row details-row--adaptive"
}
const _hoisted_32 = { class: "details-value" }
const _hoisted_33 = {
  key: 4,
  class: "details-row details-row--adaptive"
}
const _hoisted_34 = { class: "details-value" }
const _hoisted_35 = {
  key: 1,
  class: "details-block"
}
const _hoisted_36 = {
  key: 0,
  class: "details-row details-row--adaptive"
}
const _hoisted_37 = { class: "details-value" }
const _hoisted_38 = {
  key: 1,
  class: "details-row details-row--adaptive"
}
const _hoisted_39 = { class: "details-value" }
const _hoisted_40 = {
  key: 2,
  class: "details-row details-row--adaptive"
}
const _hoisted_41 = { class: "details-value" }
const _hoisted_42 = {
  key: 3,
  class: "details-row details-row--adaptive"
}
const _hoisted_43 = { class: "details-value" }
const _hoisted_44 = {
  key: 2,
  class: "details-block"
}
const _hoisted_45 = { class: "details-row details-row--adaptive" }
const _hoisted_46 = { class: "details-value" }
const _hoisted_47 = { class: "details-row details-row--adaptive" }
const _hoisted_48 = { class: "details-value" }
const _hoisted_49 = { class: "details-row details-row--adaptive" }
const _hoisted_50 = { class: "details-value" }
const _hoisted_51 = { class: "details-row details-row--adaptive" }
const _hoisted_52 = { class: "details-value" }
const _hoisted_53 = { class: "modal-wrapper" }
const _hoisted_54 = { class: "modal__description" }
const _hoisted_55 = { class: "modal-controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "card-header" }, "Contract Information Form", -1)),
    ($setup.props.eoiDetails.buyers)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            ($setup.showingControls().complete())
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button large primary",
                  onClick: $setup.onComplete
                }, "Complete"))
              : _createCommentVNode("", true),
            ($setup.showingControls().withdraw())
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "button large withdraw",
                  onClick: $setup.onWithdraw
                }, "Withdraw"))
              : _createCommentVNode("", true),
            ($setup.showingControls().delete())
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "button large withdraw",
                  onClick: $setup.onDelete
                }, "Delete"))
              : _createCommentVNode("", true),
            ($setup.showingControls().decline())
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  class: "button large withdraw",
                  onClick: $setup.onDecline
                }, "Cancel"))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.eoiDetails.buyers, (buyer, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "details-block bordered",
              key: buyer.email
            }, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(`Buyer ${index > 0 ? index + 1 : ""} Details`), 1),
              (buyer?.firstName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "details-label" }, "First Name", -1)),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(buyer.firstName), 1)
                  ]))
                : _createCommentVNode("", true),
              (buyer?.middleName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "details-label" }, "Middle Name(s)", -1)),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(buyer.middleName), 1)
                  ]))
                : _createCommentVNode("", true),
              (buyer?.lastName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "details-label" }, "Last Name", -1)),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(buyer.lastName), 1)
                  ]))
                : _createCommentVNode("", true),
              (buyer?.email)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "details-label" }, "Email", -1)),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(buyer.email), 1)
                  ]))
                : _createCommentVNode("", true),
              (buyer?.phone)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "details-label" }, "Phone Number", -1)),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(buyer.phone), 1)
                  ]))
                : _createCommentVNode("", true),
              (index < 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    (buyer?.postcode || buyer?.state)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "details-label" }, "Postcode", -1)),
                          _createElementVNode("div", _hoisted_16, _toDisplayString(buyer.postcode ? buyer.postcode : buyer.state), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (buyer?.address)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "details-label" }, "Address", -1)),
                          _createElementVNode("div", _hoisted_18, _toDisplayString(buyer.address), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_19, [
            ($setup.props?.eoiDetails?.buyerType)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "details-label" }, "Buyer Type", -1)),
                  _createElementVNode("div", _hoisted_21, _toDisplayString($setup.props.eoiDetails.buyerType), 1)
                ]))
              : _createCommentVNode("", true),
            ($setup.props?.eoiDetails?.agentReferrer)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "details-label" }, "Agent Referrer", -1)),
                  _createElementVNode("div", _hoisted_23, _toDisplayString($setup.props.eoiDetails.agentReferrer), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          ($setup.props?.eoiDetails?.conveyancer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "details-header" }, "Conveyancer Details", -1)),
                ($setup.props?.eoiDetails.conveyancer?.firmName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "details-label" }, "Firm Name", -1)),
                      _createElementVNode("div", _hoisted_26, _toDisplayString($setup.props.eoiDetails.conveyancer.firmName), 1)
                    ]))
                  : _createCommentVNode("", true),
                ($setup.props?.eoiDetails?.conveyancer?.address)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "details-label" }, "Address", -1)),
                      _createElementVNode("div", _hoisted_28, _toDisplayString($setup.props.eoiDetails.conveyancer.address), 1)
                    ]))
                  : _createCommentVNode("", true),
                ($setup.props?.eoiDetails?.conveyancer?.contactPerson?.fullName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "details-label" }, "Contact Person", -1)),
                      _createElementVNode("div", _hoisted_30, _toDisplayString($setup.props.eoiDetails.conveyancer.contactPerson.fullName), 1)
                    ]))
                  : _createCommentVNode("", true),
                ($setup.props?.eoiDetails?.conveyancer?.contactPerson?.email)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "details-label" }, "Email", -1)),
                      _createElementVNode("div", _hoisted_32, _toDisplayString($setup.props.eoiDetails.conveyancer.contactPerson.email), 1)
                    ]))
                  : _createCommentVNode("", true),
                ($setup.props?.eoiDetails?.conveyancer?.contactPerson?.phone)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "details-label" }, "Phone Number", -1)),
                      _createElementVNode("div", _hoisted_34, _toDisplayString($setup.props.eoiDetails.conveyancer.contactPerson.phone), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          ($setup.props?.eoiDetails?.contractConditions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "details-header" }, "Contract Conditions", -1)),
                ($setup.props?.eoiDetails?.contractConditions?.subjectToFinance)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "details-label wide" }, "Contract subject to finance?", -1)),
                      _createElementVNode("div", _hoisted_37, _toDisplayString($setup.props.eoiDetails.contractConditions.subjectToFinance), 1)
                    ]))
                  : _createCommentVNode("", true),
                ($setup.props?.eoiDetails?.contractConditions?.financeStatus)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "details-label wide" }, "Finance status", -1)),
                      _createElementVNode("div", _hoisted_39, _toDisplayString($setup.props.eoiDetails.contractConditions.financeStatus), 1)
                    ]))
                  : _createCommentVNode("", true),
                ($setup.props?.eoiDetails?.contractConditions?.FIRB)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "details-label wide" }, "Contract subject to FIRB?", -1)),
                      _createElementVNode("div", _hoisted_41, _toDisplayString($setup.props.eoiDetails.contractConditions.FIRB), 1)
                    ]))
                  : _createCommentVNode("", true),
                ($setup.props?.eoiDetails?.contractConditions?.otherConditions)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "details-label wide" }, "Contract subject to any other conditions?", -1)),
                      _createElementVNode("div", _hoisted_43, _toDisplayString($setup.props.eoiDetails.contractConditions.otherConditions), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          ($setup.props?.eoiDetails?.contractConditions?.financeBrokerDetails)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "details-header" }, "Finance broker details", -1)),
                _createElementVNode("div", _hoisted_45, [
                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "details-label wide" }, "Lending institution:", -1)),
                  _createElementVNode("div", _hoisted_46, _toDisplayString($setup.props.eoiDetails.contractConditions.financeBrokerDetails?.lendingInstitution || "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "details-label wide" }, "Finance broker:", -1)),
                  _createElementVNode("div", _hoisted_48, _toDisplayString($setup.props.eoiDetails.contractConditions.financeBrokerDetails?.brokerName || "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "details-label wide" }, "Email:", -1)),
                  _createElementVNode("div", _hoisted_50, _toDisplayString($setup.props.eoiDetails.contractConditions.financeBrokerDetails?.email || "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _cache[25] || (_cache[25] = _createElementVNode("div", { class: "details-label wide" }, "Phone:", -1)),
                  _createElementVNode("div", _hoisted_52, _toDisplayString($setup.props.eoiDetails.contractConditions.financeBrokerDetails?.phone || "-"), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode($setup["Modal"], {
      isOpen: $setup.showConfirmDeleteModal,
      onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.showConfirmDeleteModal = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_53, [
          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "modal__title" }, "Confirm action", -1)),
          _createElementVNode("div", _hoisted_54, _toDisplayString($setup.modalInfo.title), 1),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("button", {
              class: "button modal cancel",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showConfirmDeleteModal = false))
            }, "Cancel"),
            _createElementVNode("button", {
              class: "button modal primary",
              onClick: $setup.dynamicDelete
            }, "Confirm")
          ])
        ])
      ]),
      _: 1
    }, 8, ["isOpen"])
  ]))
}